/**
 * Created by Ning Jiang on 11/24/2016.
 */

import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";

export class DragonTribeSoundConfig implements ISoundConfig {

    public static instance:DragonTribeSoundConfig = new DragonTribeSoundConfig();
    AS_WIN:string="asWin";
    AS_WIN_BIG:string="asWinBig";
    MAIN_GAME_AMBIANCE:string = "background-music-main";
    FREE_SPIN_AMBIANCE:string = "background-music-fs";

    static BIG_WIN_LOOP:string = "bigwin";
    static BIG_WIN_END_0:string = "bigwinEnds1";
    static BIG_WIN_END_1:string = "bigwinEnds2";
    static BIG_WIN_END_2:string = "bigwinEnds3";

    static TINY_WIN:string = "winTiny";
    static SMALL_WIN:string = "winSmall";
    static MEDIUM_WIN:string = "winMedium";
    static LARGE_WIN:string = "winLarge";
    static COUNTUP:string = "countup";
    static COUNTUP_END:string = "countupEnds";

    static SYMBOL_WIN_ROW_0:string = "winRow1";
    static SYMBOL_WIN_ROW_1:string = "winRow2";

    static SYMBOL_WIN_EXPLOSIONS:string[] = ["winExplosionSingle", "winExplosion1", "winExplosion2", "winExplosion3"];
    static SPIN_FIRE:string = "spinFire";
    static WILD_NUDGE_1:string = "wildNudge1";
    static WILD_NUDGE_2:string = "wildNudge2";
    static WILD_NUDGE_3:string = "wildNudge3";
    static WILD_NUDGE_4:string = "wildNudge4";
    static WILD_NUDGE_5:string = "wildNudge5";
    static WILD_NUDGE_6:string = "wildNudge6";
    static WILD_LANDING:string = "wildLanding";
    static WILD_EXPAND:string = "wildExpand";
    static M_EXPAND:string = "xwaysExpand";
    static M_LANDING:string = "xwaysLanding";
    static M_WIN_HIGHLIGHT:string = "xwaysHighlight";

    static FS_SELECT:string = "scatter3";

    static FS_INTRO_FIRE:string = "fireLoop";
    static FS_INTRO:string = "fsIntro";
    static FS_OUTRO:string = "fsEnds";
    static FS_OUTRO_COINS:string = "fsEndsCoins";
    static ANTICIPATION:string = "anticipation";
    static ANTICIPATION_END:string = "anticipationEnds";
    static ANTICIPATION_FAIL:string = "anticipationFails";
    static SCATTER_1:string = "scatter1";
    static SCATTER_2:string = "scatter2";
    static SCATTER_3:string = "scatter3";
    static SCATTER_WIN:string = "scatterWin";
    static ANTICIPATION_SYMBOL_LANDING:string = "anticipationSymbolLanding";
    static FS_METER_FIRE_0:string = "fsMeterFire";
    static FS_METER_FIRE_1:string = "fsMeterFire2";
    static FS_METER_LIGHT:string = "fsMeterLight";
    static FS_METER_TO_WILD:string = "fsMeterToWild";
    static FS_PLUS:string = "fsPlusSpins";

    // REELS_SPIN_START?:string[];
    // REELS_SPINNING:string = "reelsSpinning";
    // REELS_SPINNING_START_ON_SPIN_START:string = "reelsSpinOut";
    static REELS_DEFAULT_BOUNCE:string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5", "reelLanding6", "reelLanding7", "reelLanding8", "reelLanding9", "reelLanding10", "reelLanding11"];
    // REELS_DEFAULT_STOP?:string[];

    REEL_SPIN_OUT:string = "reelsSpinOut";
    REEL_SPIN_IN:string = "reelsSpinIn";

    constructor() {
        if(DragonTribeSoundConfig.instance) {
            throw new Error("DragonTribeSoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}